export default __webpack_public_path__ + "static/media/US_flag_1.cafe4e6c.jpg";